module.exports = __webpack_public_path__ + "img/123.4844b0d5.png";